import React from 'react';
import './Products.css';

const Products = () => {
  return (
    <section id="products" className="products section">
      <div className="container">
        <h2 className="section-title animate-fade-in-up">Our Products & Solutions</h2>
        
        <div className="products-grid">
          <div className="product-card animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <div className="product-icon"></div>
            <h3 className="product-title">PPE Clothing & Footwear</h3>
            <p className="product-description">
              Comprehensive range of protective clothing and safety footwear designed for maximum comfort 
              and durability. From high-visibility vests to steel-toed boots, we provide the essential 
              protection your team needs for safe daily operations.
            </p>
            <div className="product-features">
              <ul>
                <li>High-visibility safety clothing</li>
                <li>Protective overalls and coveralls</li>
                <li>Safety boots and footwear</li>
                <li>Cut-resistant and chemical-resistant options</li>
              </ul>
            </div>
          </div>
          
          <div className="product-card animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="product-icon"></div>
            <h3 className="product-title">Technical Wear</h3>
            <p className="product-description">
              Specialized technical clothing engineered for demanding work environments. Our technical wear 
              combines advanced materials with ergonomic design to provide superior protection, breathability, 
              and performance in challenging conditions.
            </p>
            <div className="product-features">
              <ul>
                <li>Flame-resistant clothing</li>
                <li>Arc-rated protective wear</li>
                <li>Chemical splash protection</li>
                <li>High-temperature environments</li>
              </ul>
            </div>
          </div>
          
          <div className="product-card animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <div className="product-icon"></div>
            <h3 className="product-title">Protective Wear</h3>
            <p className="product-description">
              Complete line of protective equipment designed to enhance workplace safety across all industries. 
              Our protective wear provides crucial barriers against workplace hazards while maintaining comfort 
              and functionality for extended wear periods.
            </p>
            <div className="product-features">
              <ul>
                <li>Hard hats and head protection</li>
                <li>Safety glasses and eye protection</li>
                <li>Gloves for all applications</li>
                <li>Respiratory protection equipment</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="products-cta animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <p>
            <strong>Visit us today and experience the Totalguard Workwear Rosslyn difference.</strong> Our expert team is ready 
            to help you find the perfect PPE solutions for your specific needs and requirements.
          </p>
          <a href="#contact" className="btn">Request a Quote</a>
        </div>
      </div>
    </section>
  );
};

export default Products;
